// Version : 0.0.1
// Author : AGALYA

import ActiveMemberActionTypes from './active-member.types';

/** ***************** GET ACTIVE MEMBER START *********************** */
export const getActiveMemberDetailsStart = (getData: any) => ({
	type: ActiveMemberActionTypes.GET_ACTIVE_MEMBER_LIST_START,
	payload: getData,
});

export const getActiveMemberDetailsSuccess = (successData: any) => ({
	type: ActiveMemberActionTypes.GET_ACTIVE_MEMBER_LIST_SUCCESS,
	payload: successData,
});

export const getActiveMemberDetailsFailure = (failureData: any) => ({
	type: ActiveMemberActionTypes.GET_ACTIVE_MEMBER_LIST_FAILURE,
	payload: failureData,
});

export const getActiveMemberDetailsResponseResetStart = () => ({
	type: ActiveMemberActionTypes.GET_ACTIVE_MEMBER_LIST_RESPONSE_RESET,
});

export const getActiveMemberDetailsResponseChanged = () => ({
	type: ActiveMemberActionTypes.GET_ACTIVE_MEMBER_LIST_RESPONSE_CHANGED,
});
/** ***************** GET ACTIVE MEMBER END *********************** */
